/* eslint-disable no-param-reassign */
import axios from 'axios';
import { NotificationManager } from 'react-notifications';
import { getToken } from './authentication';
import i18n from '~/i18n';
import { getTenant } from '~/services/multiTenant';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  responseType: 'json',
});

api.CancelToken = axios.CancelToken;

api.interceptors.request.use(async (config) => {
  // FLUXO ENCODED
  const decodedToken = getToken();

  if (decodedToken) {
    // const decodedToken = jwt_decode(token)
    // eslint-disable-next-line no-param-reassign
    config.headers.Authorization = `${decodedToken.token}`;
  }

  if (decodedToken && config.url === '/logout') {
    // const decodedToken = jwt_decode(token)
    config.headers.Authorization = `${decodedToken.refresh_token}`;
    // config.headers.Authorization = `${decodedToken.refresh_token}`;
  }

  const tenant = getTenant();
  if (tenant) {
    // eslint-disable-next-line no-param-reassign
    config.headers['x-tenant-id'] = `${tenant}`;
  }
  // eslint-disable-next-line no-param-reassign
  config.headers.Language = i18n.language;
  return config;

  //-------
  // FLUXO FUNCIONAL
  // console.log('API INTERCEPTOR')
  // const token = getToken();
  // console.log('token', token)
  // if (token) {
  //   console.log('token on')
  //   // eslint-disable-next-line no-param-reassign
  //   config.headers.Authorization = `${token}`;
  // }

  // const tenant = getTenant();
  // if (tenant) {
  //   // eslint-disable-next-line no-param-reassign
  //   config.headers['x-tenant-id'] = `${tenant}`;
  // }
  // // eslint-disable-next-line no-param-reassign
  // config.headers.Language = i18n.language;
  // console.log('config.headers', config.headers)
  // return config;
});

// Função desnecessária
// Adicionar tratamento erro de sessao expirada
api.interceptors.response.use(
  async response => response,
  async (error) => {
    if (error.message === 'Network Error') {
      NotificationManager.warning(
        i18n.t('common:NoConnection'),
        i18n.t('common:NetworkError'),
        5000,
      );
    }

    return Promise.reject(error);
  },
);
// api.interceptors.response.use(async (response) => {
//   console.log('INTERCEPTOR DE TRATAMENTO DE ERRO')
//   const { data } = response;
//   console.log('data', data)
//   if (data) {
//     if (data.new_token) {
//       setToken(data.new_token);
//     }
//   }
//   return response;
// }, async error => Promise.reject(error));

export default api;
